export default "__VITE_ASSET__819e2924__"